(function () {
  var KLAVIYO_COMPANY_ID = 'XciWSp';
  var API_URL = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY_ID;

  function getForm(sectionId) {
    return document.getElementById('klaviyo-bis-form-' + sectionId);
  }

  function showForm(form, variantId) {
    form.classList.remove('klaviyo-bis-form--hidden');
    form.dataset.variantId = variantId;
    var successMsg = form.querySelector('.klaviyo-bis-form__success');
    if (successMsg) successMsg.classList.add('klaviyo-bis-form--hidden');
    var input = form.querySelector('.klaviyo-bis-form__email');
    if (input) input.value = '';
    var submitBtn = form.querySelector('.klaviyo-bis-form__submit');
    if (submitBtn) submitBtn.disabled = false;
  }

  function hideForm(form) {
    form.classList.add('klaviyo-bis-form--hidden');
  }

  document.addEventListener('variant:change', function (event) {
    var detail = event.detail;
    var variant = detail.variant;
    var sectionId = detail.sectionId;
    if (!sectionId && detail.formElement) {
      var sectionEl = detail.formElement.closest('[data-section]');
      if (sectionEl) sectionId = sectionEl.dataset.section;
    }
    var form = getForm(sectionId);
    if (!form) return;
    if (variant && variant.available === false) {
      showForm(form, variant.id);
    } else {
      hideForm(form);
    }
  });

  document.addEventListener('variant:unavailable', function (event) {
    var form = getForm(event.detail.sectionId);
    if (!form) return;
    form.classList.remove('klaviyo-bis-form--hidden');
  });

  document.addEventListener('click', function (event) {
    if (!event.target.matches('.klaviyo-bis-form__submit')) return;
    var submitBtn = event.target;
    var form = submitBtn.closest('.klaviyo-bis-form');
    if (!form) return;
    var emailInput = form.querySelector('.klaviyo-bis-form__email');
    var email = emailInput ? emailInput.value.trim() : '';
    var variantId = form.dataset.variantId;
    if (!email || !variantId) return;

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };

    submitBtn.disabled = true;

    fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-06-15'
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (res.status === 202 || res.ok) {
          var successMsg = form.querySelector('.klaviyo-bis-form__success');
          if (successMsg) successMsg.classList.remove('klaviyo-bis-form--hidden');
          if (emailInput) emailInput.value = '';
        } else {
          submitBtn.disabled = false;
        }
      })
      .catch(function () {
        submitBtn.disabled = false;
      });
  });
})();
